var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return JSON.stringify(_vm.datas) !== "{}"
    ? _c("div", { staticClass: "container" }, [
        _vm.orderType != 5 && _vm.orderType != 1
          ? _c(
              "div",
              { staticClass: "column" },
              [
                _c("div", { staticClass: "columnText1" }, [
                  _vm._v(" 预定说明 "),
                ]),
                _c("reserve", {
                  attrs: { datas: _vm.datas, state: _vm.state },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.orderType != 5 && _vm.orderType != 1
          ? _c(
              "div",
              { staticClass: "column" },
              [
                _c("div", { staticClass: "columnText1" }, [
                  _vm._v(" 费用说明 "),
                ]),
                _c("cost", {
                  attrs: {
                    orderType: _vm.orderType,
                    datas: _vm.datas,
                    state: _vm.state,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.orderType != 5 && _vm.orderType != 1
          ? _c(
              "div",
              { staticClass: "column" },
              [
                _c("div", { staticClass: "columnText1" }, [
                  _vm._v(" 使用说明 "),
                ]),
                _vm.state == 0
                  ? _c("hotel-use", { attrs: { datas: _vm.datas } })
                  : _vm._e(),
                _vm.state == 1
                  ? _c("site-use", { attrs: { datas: _vm.datas } })
                  : _vm._e(),
                _vm.state == 2 || _vm.state == 8
                  ? _c("spot-use", { attrs: { datas: _vm.datas } })
                  : _vm._e(),
                _vm.state == 4
                  ? _c("restaurant-use", { attrs: { datas: _vm.datas } })
                  : _vm._e(),
                _vm.state == 5
                  ? _c("guide-use", { attrs: { datas: _vm.datas } })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("div", { staticClass: "columnText1" }, [_vm._v(" 退改说明 ")]),
            _c("ticket", { attrs: { datas: _vm.datas } }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("div", { staticClass: "columnText1" }, [_vm._v(" 其他说明 ")]),
            _c("other", { attrs: { datas: _vm.datas } }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }